import { motion } from "framer-motion";
import { PROCESS } from "../../lib/data";
import { Reveal, Overline } from "../Reveal";

export const ProcessSection = () => (
  <section className="bg-[#050505] text-white py-24 md:py-32 px-6" data-testid="process-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal><Overline dark>Nasz proces</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.02] font-semibold">
                Spokojna, przemyślana droga od pomysłu do <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>efektu.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-white/55 max-w-sm">Pięć prostych etapów. Jasny proces, konkretne ustalenia i rozwiązania dopasowane do Twojej firmy.</p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8 lg:col-start-5">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={0.04 * i}>
              <motion.div
                data-testid={`process-step-${i}`}
                className="group flex items-start gap-6 md:gap-10 py-6 md:py-[26px] border-t border-white/10 last:border-b"
              >
                <span className="text-sm font-mono text-white/30 pt-2 w-10 shrink-0 transition-colors group-hover:text-[var(--gold)]">{p.n}</span>
                <div className="h-11 w-11 shrink-0 rounded-full border border-white/15 flex items-center justify-center mt-0.5 transition-colors duration-500 group-hover:border-[var(--gold)] group-hover:text-[var(--gold)]">
                  <p.icon size={18} strokeWidth={1.5} />
                </div>
                <div className="flex-1 pr-[14px] md:pr-0">
                  <h3 className="text-2xl md:text-3xl font-semibold tracking-tight transition-transform duration-500 group-hover:translate-x-1">{p.title}</h3>
                  <p className="mt-2 text-white/55 max-w-lg leading-relaxed">{p.desc}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
